import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/// <reference path="../../types.d.ts"" />
import { Card } from '@codametrix/ui-components';
import classnames from 'classnames';
import React, { useState, useEffect } from 'react';
import './dashboard.scss';
const listeners = [
    'firstinteractive',
    'filterchanged',
    'parameterchanged',
    'markselectionchanged'
];
const TableauDashboard = (props)=>{
    const { tableauInfo, instantiateDashboard, serviceLine, tableauToken, activeHealthSystemCode, activeDashboardResource, registerActivity, dashboardPaths } = props;
    const [instantiated, setInstantiated] = useState(false);
    useEffect(()=>{
        if (tableauInfo?.enabled) {
            if (!instantiated) {
                setInstantiated(true);
                instantiateDashboard(serviceLine);
            }
            // Get the viz object from the HTML web component
            const viz = document.querySelector('tableau-viz');
            listeners.forEach((listener)=>{
                viz?.addEventListener(listener, registerActivity);
            });
        }
    }, [
        instantiated,
        instantiateDashboard,
        registerActivity,
        tableauInfo?.enabled,
        serviceLine,
        tableauToken
    ]);
    useEffect(()=>{
        return ()=>{
            setInstantiated(false);
            const viz = document.querySelector('tableau-viz');
            listeners.forEach((listener)=>{
                viz?.removeEventListener(listener, registerActivity);
            });
        };
    }, [
        registerActivity
    ]);
    const { loadState } = props;
    const styleClasses = [
        'dashboard-view'
    ];
    const showCard = loadState.error || tableauInfo?.enabled === false;
    let message;
    if (showCard) {
        message = loadState.error ? `An error has occurred loading the dashboard.` : `Analytics is not enabled.  Please contact someone from CodaMetrix for more information.`;
    }
    const serviceLineFilter = serviceLine?.name?.length ? `${serviceLine?.name?.replace(/ /g, '')}` : '';
    // Temporary hardcoding, our dashboards do not support AMCHS org code at this time
    const healthSystemCodeFilter = activeHealthSystemCode !== 'AMCHS' ? activeHealthSystemCode : '';
    const filters = serviceLine && serviceLine?.name?.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("viz-filter", {
                field: "Service Line",
                value: serviceLineFilter
            }),
            /*#__PURE__*/ _jsx("viz-filter", {
                field: "Health System Code",
                value: healthSystemCodeFilter
            })
        ]
    }) : /*#__PURE__*/ _jsx("viz-filter", {
        field: "Health System Code",
        value: healthSystemCodeFilter
    });
    const link = activeDashboardResource ? `${tableauInfo?.siteUrl}${dashboardPaths[activeDashboardResource]}` : '';
    return /*#__PURE__*/ _jsx("div", {
        className: classnames(styleClasses),
        children: tableauInfo?.enabled && instantiated ? /*#__PURE__*/ _jsx("tableau-viz", {
            id: "tableauViz",
            src: link,
            token: tableauToken,
            toolbar: "hidden",
            children: filters
        }) : /*#__PURE__*/ _jsxs(Card, {
            className: "content-vacant",
            children: [
                ' ',
                /*#__PURE__*/ _jsx("h2", {
                    children: message
                })
            ]
        })
    });
};
export default TableauDashboard;
